import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Route } from '@angular/compiler/src/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { DOCUMENT } from '@angular/common';
import { Observable,of } from 'rxjs';
declare let $: any;
interface Task {
  id: number;
  title: string;
  dueDate: string;
  
}
@Injectable({
  providedIn: 'root'
})
export class AppService {
    upcomingWeekTasks: Task[] = []; 
  public access_tocken = "";
  public Server_URL = "https://crmapi.lapstiersolutions.in/";//https://crmapi.lapstiersolutions.in///http://localhost:50432/
  public Quotation_Format="Format1";
  public System_mac_address="Not found"
  public Area_Map: boolean = false;
  public NT_Bill_Format = "NT_Format1"
  public Bill_Format = "Format1"
  public Bill_Format1 = "Format6";
  public Vadi_Format = "Format1";
  public check_Unicod: boolean = false;

  public TCS_Enable: boolean = true;
  public Balance_SMS = "false";

  public key_value="";

  public Intrest_Format="Flat"

  public NT_Printer: string = "false";
  public NT_Address: String = "http://localhost:55245/";

  public DB_Vadi_display: boolean = false;
  public Print_Button: boolean = false;

  public Ledger_Update:boolean=true;
  public Cust_Amt: boolean = false;
  public Lfrom = "34";
  public Top = 50;

  public Logo_location = "Letter";
  public Logo_Name = "Qubha";
  public Logo_location_Loin = "Chef";
  public Logo_Sub_Name = "Soft";
  public Phone_No = "9597436220";
  public Lab_Home_Page = "/dashboard/default";
  public header_hide:boolean=false;

  public Cam_Type = "Proof";
  public Proof_Image: any;
  public Visa_Image: any;
  public Empty_Image: any;

  public disp_mmenu:boolean=false;
  public Qmenu: boolean = true;
  public STamilName: boolean = false;
  public Type_Based_Bill_No: boolean = false;
  public Item_Rate_Update: boolean = true;
  public Check_Stock: boolean = false;
  
  public Image_disp: boolean = false;
  public Ledger_Type = "1";

  public Group_Enable: boolean = false;
  public Print_Bill: boolean = false;
  
  public Save_Print: boolean = true;
  public Save_Print_Mobile: boolean = false;
  public Save_New: boolean = false;

  public  Stockbase_Sales: boolean = false;

  public  mobile_menu: boolean = false;

  public User_Master_Rows = [];
  get_User_Master() {
    this.getc("Api/Common/get_User_Master").subscribe((res: any) => {
      this.User_Master_Rows = JSON.parse(res).record;
    });
  }

  public Prof_Required:boolean =true;
  public Req_Camera: boolean = false;
  
  public from_customer_page:boolean=false;
  public W_height = 0;
  public W_width = 0;

  public SM_Row = [];
  public Sales_Disp_Text2_Visblle: boolean = false;
  public Sales_Disp_Text3_Visblle: boolean = false;
  public Task=[];
  public Loan_Issue_Page="/collection/emi-loan-issue";
  public Add_Receipt_Page="/transaction/add-receipt-entry-two";
  public U_Rights=""
  public Item_Group_ = "1";
  public isadd_Page:boolean=false;
  lenth: number = 0;
  constructor(@Inject(DOCUMENT) private document: Document, private toastr: ToastrService, public datePipe: DatePipe, public http: HttpClient, public router: Router, private _location: Location) {


    if (this.getData()) {
      this.data = JSON.parse(localStorage.getItem('User_Data'));
      try {
        this.Customer_Area = localStorage.getItem('Area');
      } catch { }
      this.Company = "_" + this.data.UM_Company;
      this.Branch=this.data.UM_Branch;
      this.Division=this.data.UM_Division;
      if(this.data.Rights_Name.toLowerCase()=="staff")
        {
        this.UserId=this.data.UM_ID;
        }
      this.Rights_Name=this.data.Rights_Name;
    }
    


    this.W_height = window.innerHeight;

    this.W_width = window.innerWidth;

    var Today_Date = this.datePipe.transform(new Date(), "dd-MMM-yyyy");

    this.T_Date = this.datePipe.transform(new Date(), "yyyy-MM-dd");

    this.T_Date_Time = this.datePipe.transform(new Date(), "yyyy-MM-ddTHH:mm");

    this.exp_Date = this.datePipe.transform(new Date(), "MM/yy");
    this.Pay_Date = this.datePipe.transform(new Date(), "yyyy-MM-dd");

    this.Y_Date = this.datePipe.transform(new Date().getDate() - 1, "dd-MMM-yyyy");
    this.Today_Date = Today_Date;

    this.S_From_ = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.S_From = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.S_To = this.datePipe.transform(new Date(), "yyyy-MM-dd");

    this.From_Date = { formatted: Today_Date };
    this.To_Date = { formatted: Today_Date };
    this.Date = { formatted: Today_Date };
    this.Date1 = { formatted: Today_Date };

    this.headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    this.load_themes('');
  }

  public lable_ = "";
  public item = "";
  public Filter_Type = "contain";

  public openModal: boolean = false;
  Open_Modal(Title, page) {
    this.openModal = true;
    $('#small_Module').modal('show');
  }

  Close_Modal() {
    this.openModal = false;
    $('#small_Module').modal('hide');
  }

  public Header_Disp = "";

  public add_item_name = "/add-items1";
  btndisable: boolean = false;
  isload: boolean = false;
  public Company = "";
  public Branch = "0";
  public Division = "";
  public UserId = "0";
  public CREATED_BY = "";
  public Ref_ID = "0";
  public isadd = "0";
  public Edit_Row: any = {};
  public Edit_Row1: any = {};

  public Selected_Row: any = {};
  public Default_ref_ID: string = "Role";
  public URL_Location = "";

  public disp_category:boolean=false;
  public img_visible: boolean = false;

  public Date;
  public Date1;
  public From_Date;
  public To_Date;
  public S_From_ = "";

  public User_Type = "Admin";
  public Document_Type = "Front_Banner";
  public Phone_Pattern = "^((\\+91-?)|0)?[0-9]{10}$";
  public Receipt_Print="false";

  public Side_Menu: boolean = false;
  public Today_Date = "";
  public S_From = "";
  public S_To = "";
  public FS_Date = "2021-04-01";

  public S_Bill_Type = "All";
  public S_Thari_Status = "All";
  public Calibration_Standard ="";
  public Category = "All";

  public S_Pay_Mode = "0";
  public S_Bill_Mode = "All";
  public S_Area = "All"
  public S_Sales_Order_by = "Bill_No";
  public S_Stock = "All"
  public S_Sales_Person = "All"
  public S_Type = "1"

  public Y_Date = "";
  public data: any = {};
  public Order_Status = "Pending";
  public Search_User = "All";
  public Approval_Status = "Pending";

  public Customer_Area = "All";
  public item_name_disp = "English";

  public T_Date = "";
  public T_Date_Time = "";

  public T_Status="A";

  public Pay_Date="";
  public exp_Date="";
  public Open_Customer_Total = 0;
  public Open_Customer_Length = 0;
  public DB_Expense_Total=0;
  public Receipt_Row_Total=0;
  public Emi_Loan_Issue_Total=0;
  public DB_Bank_Row=0;
  public DB_Bank_Total=0;

  public Item_Group="";
  public User_Role_Menu = [
    { Menu: 'User Master', Link: '/user-details' },
    { Menu: 'Role Master', Link: '/role-master' },
    { Menu: 'Role Rights', Link: '/role-permissions' }

  ];

  
  public Menu_Master_GF = ['Module', 'Type', 'Display_Name', 'Route_Link', 'Order_No', 'Icon', 'Remark'];
  public back() {
    this._location.back();
  }
 getUpcomingWeekTasks(): Observable<Task[]> {
    return this.http.get<Task[]>('YOUR_API_URL_HERE');
  }

getPipelineStageChart(from: string, to: string) {
  return this.get(
    `Api/transaction/get_Pipeline_StageChart?From=${from}&To=${to}`
  );
}

getTaskCountByWeek() {
  return this.get(
    `Api/transaction/get_TaskCount_ByWeek`
  );
}

  public datefromat(data) {
    return this.datePipe.transform(data, "yyyy-MM-dd");
  }

  public datefromat105(data) {
    return this.datePipe.transform(data, "yyyy-MM-dd");
  }

  public datetimefromat(data) {
        // Split and rearrange the string to be in 'YYYY-MM-DD HH:mm:ss' format
  // const [day, month, yearTime] = data.split("-");
  // const [year, time] = yearTime.split(" ");
  // const formattedDateStr = `${year}-${month}-${day} ${time}`;

  // // Convert the string into a JavaScript Date object
  // const dateObj = new Date(formattedDateStr);
    return this.datePipe.transform(data, "yyyy-MM-ddTHH:mm");
  }
  

  get_dt(date) {
    return this.datePipe.transform(date, "yyyy-MM-dd");
  }

  public date_display(data) {
    return this.datePipe.transform(data, "dd-MMM-yyyy");
  }

  public calculateAge(birthDate: Date): number {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    //Adjust age if the birth month/day hasn't occurred yet in the current year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  public Rights_Name = "";
  public Rights_ID = "";
  public Emp_ID = "";
  getFile(url: string): Promise<Blob> {
    return this.http.get(url, { responseType: 'blob' }).toPromise();
  }
  
  convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  getData() {
    return JSON.parse(localStorage.getItem('User_Data'));
  }

  F_Row = [];
  get_pos_field(Table, pos) {
    this.F_Row = this.Field_Setting.filter(e => String(e.Table_Name).toLowerCase() == String(Table).toLowerCase()).filter(e => e.Visible == "True");
    this.F_Row = this.F_Row.filter(e => String(e.Posision).toLowerCase() == String(pos).toLowerCase());
    return this.F_Row.sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));
  }
  
  L = [];
  get_Array(data) {
    this.L = data.split(",");
    return this.L;
  }

  Ln = "";
  get_Column_Array(data,Field) {
    this.Ln = data.find(c => c.Field.toLowerCase() === Field.toLowerCase())?.Name 
    return this.Ln;
  }

  Reference_Rows = [];
  get_Reference() {
    this.getc("Api/Master/get_reference").subscribe((res: any) => {   
      this.Reference_Rows = JSON.parse(res).record;
    });
  }

  Product_Rows = [];
  public isEdit: boolean = false;
  public load_from_make_invoice: boolean = false;

  public Default_Search_Branch = "0";

  public Selected_Company: any = {};
  public Selected_Customer: any = {};
  public Current_User: any = {};

  public Order_No = "0";
  public Menus_Rows: any = {};
  public Menu_Rows = [];
  public Label_Menu_Rows = [];
  get_Role_Rights(Role) {
    this.get("Api/Setting/get_Menu_for_user?Rights=" + Role).subscribe((res: any) => {
      this.Menu_Rows = JSON.parse(res).record;
      this.Side_Menu = true;
      try {
        this.Label_Menu_Rows = this.Menu_Rows.filter(e => e.Type == "Label");
        this.Label_Menu_Rows = this.Label_Menu_Rows.filter(e => e.Parent_ID == "0");
        this.Label_Menu_Rows.sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));
      } catch { }
    });
  }


  get_ref(data) {     
    try{
    return this.Reference_Rows.filter(e => e.Ref_ID == data).sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));
    }catch{
      return [];
    }
  }
  get_child(parent) {
    var data = this.Menu_Rows.filter(e => e.Parent_ID == parent).sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));
    return data;
  }

  get_childs(parent) {
    var data = this.Menu_Rows.filter(e => e.Module == parent).sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));
    return data;
  }

  public Menu_data = "";
  public Menu_Master_Rows = [];
  public Parent_Menus = [];
  get_Menu_Master() {
    this.getc("Api/Setting/get_Menu_master").subscribe((res: any) => {
      this.Menu_Master_Rows = JSON.parse(res).record;
      this.Parent_Menus = this.Menu_Master_Rows.filter(e => e.Parent_ID == "0");
   });
  }

  loading = false;


  Num(data) {
    return Number(data).toFixed(2);
  }

  public filter_data="";
  pdfType = "Open";


  get(url) { 
    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Content-Type': 'text/plain',
      'Authorization': 'Bearer ' + this.access_tocken
    });
    return this.http.get(this.Server_URL + "" + url + "&Company=" + this.Company, { headers: reqHeader })
  }

  getc(url) {
    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Authorization': 'Bearer ' + this.access_tocken
    });
    return this.http.get(this.Server_URL + "" + url + "?Company=" + this.Company, { headers: reqHeader });
  }

  d_get(url) {
    this.access_tocken = this.tocken;
    var reqHeader = new HttpHeaders({
      'Content-Type': 'text/plain',
      'Authorization': 'Bearer ' + this.access_tocken
    });
    return this.http.get(url + "&Company=" + this.Company, { headers: reqHeader })
  }


  public load_page(data) {
    this.router.navigate([data], { replaceUrl: true });
  }

  public load_page1(data) {
    this.router.navigate([data]);
  }

  public Serial_No_Settings_Rows = [];
  public Perment_Serial_No_Settings_Rows = [];
  public Reset_Serial_No_Settings_Row = [];
  public Orderby_Name = "Name";
  get_Serial_No_Settings() {
    this.loading = true;
    this.isload = true;
    this.Serial_No_Settings_Rows = [];
    this.get("Api/Setting/get_Serial_No_Settings?Order_by=" + this.Orderby_Name).subscribe((res: any) => {
      this.Serial_No_Settings_Rows = JSON.parse(res).record;
      this.Perment_Serial_No_Settings_Rows = JSON.parse(res).record;
      this.Reset_Serial_No_Settings_Row = JSON.parse(res).record;
      this.loading = false;
      this.isload = false;
      //this.Item_Category = [...new Set(this.Item_Master_Rows.map(item => item.Category))];
      //console.log(this.Item_Category);
    });
  }

  public Variable_Settings_Rows = [];
  public Perment_Variable_Settings_Rows = [];
  public Reset_Variable_Settings_Row = [];
  public Variable_Settings_GF = ['ID', 'S_Variable', 'S_Value', 'S_Default'];

  get_Variable_Settings() {
    this.loading = true;
    this.Variable_Settings_Rows = [];
    this.getc("Api/Setting/get_variable_Settings").subscribe((res: any) => {
      this.Variable_Settings_Rows = JSON.parse(res).record;
      this.Perment_Variable_Settings_Rows = JSON.parse(res).record;
      this.Reset_Variable_Settings_Row = JSON.parse(res).record;
      this.loading = false;
    });
  }


  post_data(data, Table) {
    data.Company = this.Company;
    data.Created_by = this.CREATED_BY;
    data.Table_Name = Table;
    this.headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    this.isload = true;
    this.http.post(this.Server_URL + 'api/Master/Post_Data', data, { headers: this.headers })
      .subscribe(
        (val: string) => {
          this.isload = false;
          return val;
        },
        response => {
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
          return "Error Contact Admin";
        });

    //return "Problem"
  }


  public tocken = "";
  get_Token() {
    this.headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    this.isload = true;
    this.http.post(this.Server_URL + 'token', 'grant_type=password&UserName=admin&Password=admin', { headers: this.headers })
      .subscribe(
        (val) => {
          this.tocken = val['access_token'];
        },
        response => {
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
          return "Error Contact Admin";
        });
    //return "Problem"
  }

  public filteredValue(dt) {
    var len = 0;
    var dt2 = [];
    try {
      len = dt.filteredValue.length;
      dt2 = dt.filteredValue;
      return dt2
    } catch { }

    if (len == 0) {
      try {
        dt2 = dt.value;
      } catch { }
    }
    return dt2;
  }

  public length_of(dt) {
    var len = 0;
    try {
      len = dt.filteredValue.length;
      return len
    } catch { }

    if (len == 0) {
      try {
        len = dt.value.length;
      } catch { }
    }
    return len;
  }

  load_themes(data) {
    var d = "default.css";
    try {
      d = localStorage.getItem('Theme');
    } catch { }
    if (d != "default.css" && d != null) {
      this.loadStyle(d);
    }
  }

  loadStyle(styleName: string) {
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById(
      'client-theme'
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = `${styleName}`;
      head.appendChild(style);
    }
  }

  public sum_of(dt, field) {
    var len = 0;
    try {
      len = dt.filteredValue.length;
      return dt.filteredValue.reduce((sum, current) => sum + parseFloat(current[field]), 0);
    } catch { }


    if (len == 0) {
      try {
        len = dt.value.length;
        return dt.value.reduce((sum, current) => sum + parseFloat(current[field]), 0);
      } catch { }
    }
    return len;
  }

  Open_Modal1(Title, page) {
    this.openModal = true;
    $('#small_Module').modal('show');
  }

  public Excel_Data: any = {
    'ID': '',
    "item": '',
    "Header": '',
    "Footer": '',
    "Left_Data": '',
    "Right_Data": '',
    "Report_Name": ''
  };
  headers;

  export_excel() {
    this.Excel_Data.Company = this.Company;
    this.Excel_Data.User = this.CREATED_BY;
    this.headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });

    this.http.post(this.Server_URL + 'api/master/JsontToExcel', this.Excel_Data, { headers: this.headers })
      .subscribe(
        (val: string) => {
          if (val == "True") {
            var parm = "User=" + this.CREATED_BY + "&Company=" + this.Company + "&File_Name=" + this.File_Name + "&File_Type=xls";
            window.open(this.Server_URL + "Home/JsontToExcel?" + parm, "_blank");
            this.toastr.success("Data Exported  Successfully", 'Msg');
          }
          else {
            console.log(val);
            this.toastr.error(val, "Error", { timeOut: 3000 });
          }
        },
        response => {
          console.log(response);
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
        });
  }
  upload_excel() {
    this.Excel_Data.Company = this.Company;
    this.Excel_Data.User = this.CREATED_BY;
    this.headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });

    this.http.post(this.Server_URL + 'api/master/JsontToExcel', this.Excel_Data, { headers: this.headers })
      .subscribe(
        (val: string) => {
          if (val == "True") {
            var parm = "User=" + this.CREATED_BY + "&Company=" + this.Company + "&File_Name=" + this.File_Name + "&File_Type=xls";
            window.open(this.Server_URL + "Report/JsontToExcel_Upload?" + parm, "_blank");
            this.toastr.success("Data Exported  Successfully", 'Msg');
          }
          else {
            console.log(val);
            this.toastr.error(val, "Error", { timeOut: 3000 });
          }
        },
        response => {
          console.log(response);
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
        });
  }
  //loading = false;

  public Dashboard_Row = [];
  get_Dashboard() {
    this.Dashboard_Row = [];
    this.loading = true;
    this.get("Api/Master/get_dashboard?").subscribe((res: any) => {
      this.Dashboard_Row = JSON.parse(res).record;
      this.loading = false;
    });
  }


  public dashboard_data() {
    //this.get_S_CompanyName();this.get_S_ContactName();

    this.get_Employee_Details();
    this.get_S_Branch_Details();
    this.get_S_Branch_Details_Rpt();
    this.get_Region_Master();
  }

  File_Name = "Data";

  export_pdf() {
    this.Excel_Data.Company_Data = JSON.parse(JSON.stringify(this.Current_User));
    this.Excel_Data.Company = this.Company;
    this.Excel_Data.User = this.CREATED_BY;

    this.headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    this.http.post(this.Server_URL + 'api/master/JsontToExcel', this.Excel_Data, { headers: this.headers })
      .subscribe(
        (val: string) => {
          if (val == "True") {
            var parm = "User=" + this.CREATED_BY + "&Company=" + this.Company + "&File_Name=" + this.File_Name + "&File_Type=pdf";
            window.open(this.Server_URL + "PDF/Export_Pdf?" + parm, "_blank");
            this.toastr.success("Data Exported  Successfully", 'Msg');
          }
          else {
            console.log(val);
            this.toastr.error(val, "Error", { timeOut: 3000 });
          }
        },
        response => {
          console.log(response);
          this.toastr.error('Error ', response, {
            timeOut: 3000
          });
        });
  }

  get_fields_of(Table) {
    this.F_Row = this.Field_Setting.filter(e => String(e.Table_Name).toLowerCase() == String(Table).toLowerCase()).filter(e => e.Visible == "True");
    return this.F_Row.sort((a, b) => Number(a["Order_No"]) - Number((b["Order_No"])));
  }

  get_grid_fields_of(Table) {
    this.F_Row = this.Field_Setting.filter(e => String(e.Table_Name).toLowerCase() == String(Table).toLowerCase()).filter(e => e.GVisible == "True");
    return this.F_Row.sort((a, b) => Number(a["GOrder"]) - Number((b["GOrder"])));
  }

  public Field_Setting = [];
  get_Field_Setting() {
    this.getc("Api/Setting/get_Field_Setting").subscribe((res: any) => {
      this.Field_Setting = JSON.parse(res).record;
    });

  }
  public Field_Setting_Table_Row = [];
  get_Field_Setting_Table() {
    this.getc("Api/Setting/get_Field_Setting_Table").subscribe((res: any) => {
      this.Field_Setting_Table_Row = JSON.parse(res).record;
    });
  }

  public CompanyName_Row = [];
  get_CompanyName() {
    this.getc("Api/Setting/get_CompanyName").subscribe((res: any) => {
      this.CompanyName_Row = JSON.parse(res).record;
    });
  }

  public ContactName_Row = [];
  get_ContactName() {
    this.getc("Api/Setting/get_ContactName").subscribe((res: any) => {
      this.ContactName_Row = JSON.parse(res).record;
    });
  }

  public Status="A";

  public S_LeadContacts_Row=[];
  public Search_LeadContacts = "0";
  get_S_LeadContactForCompany(name) {
    debugger
    this.isload = true;
    this.S_LeadContact_Row=[];
    this.get("Api/transaction/get_LeadContactForCompany?UserId=" + name + "&Branch=" + this.Search_Branch + "&Division=" + this.Division+"&RptType=Entry").subscribe((res: any) => {
    this.S_LeadContacts_Row = JSON.parse(res).record;
    this.Search_LeadContacts = this.S_LeadContacts_Row[0].value;
    this.isload = false;
    });
  }

  public S_LeadContact_Row=[];
  public Search_LeadContact = "0";
  get_S_LeadContact() {
    debugger
    this.isload = true;
    this.S_LeadContact_Row=[];
    this.get("Api/transaction/get_LeadContact?UserId=" + this.UserId + "&Branch=" + this.Search_Branch + "&Division=" + this.Division+"&RptType=Entry").subscribe((res: any) => {
    this.S_LeadContact_Row = JSON.parse(res).record;
    this.Search_LeadContact = this.S_LeadContact_Row[0].value;
    this.isload = false;
    });
  }

  public S_IndustryType_Row=[];
  public Search_Industry = "0";
  get_S_IndustryType() {
    debugger
    this.isload = true;
    this.S_IndustryType_Row=[];
    this.get("Api/transaction/get_IndustryType?UserId=" + this.UserId + "&Branch=" + this.Search_Branch + "&Division=" + this.Division+"&RptType=Entry").subscribe((res: any) => {
    this.S_IndustryType_Row = JSON.parse(res).record;
    this.Search_Industry = this.S_IndustryType_Row[0].value;
    this.isload = false;
    });
  }

  public S_ContactName_Row=[];
  public Search_Contact = "0";
  get_S_ContactName() {
    debugger
    this.isload = true;
    this.S_ContactName_Row=[];
    this.get("Api/transaction/get_ContactName?UserId=" + this.UserId + "&Branch=" + this.Search_Branch + "&Division=" + this.Division+"&RptType=Entry").subscribe((res: any) => {
    this.S_ContactName_Row = JSON.parse(res).record;
    this.Search_Contact = this.S_ContactName_Row[0].value;
    this.isload = false;
    });
  }

  public S_Deal_Row=[];
  public Search_Deal = "0";
  get_S_Deal(name: string) {
    debugger
    this.isload = true;
    this.S_Deal_Row=[];
    this.get("Api/transaction/pr_fetch_deal?UserId=" + name + "&Branch=" + this.Search_Branch + "&Division=" + this.Division+"&RptType=Entry").subscribe((res: any) => {
    this.S_Deal_Row = JSON.parse(res).record;
    this.Search_Deal = this.S_Deal_Row[0].value;
    this.isload = false;
    });
  }

  public S_Deal_Row_Report=[];
  public Search_Deal_Report = "0";
  get_S_Deal_Report() {
    debugger
    this.isload = true;
    this.S_Deal_Row_Report=[];
    this.get("Api/transaction/pr_fetch_deal_Report?UserId=" + name + "&Branch=" + this.Search_Branch + "&Division=" + this.Division+"&RptType=Entry").subscribe((res: any) => {
    this.S_Deal_Row_Report = JSON.parse(res).record;
    this.Search_Deal_Report = this.S_Deal_Row_Report[0].value;
    this.isload = false;
    });
  }

  public S_CompanyName_Row=[];
  public Search_Company = "0";
  get_S_CompanyName() {
    debugger
    this.isload = true;
    this.S_CompanyName_Row=[];
    this.get("Api/transaction/get_CompanyName?UserId=" + this.UserId + "&Branch=" + this.Search_Branch + "&Division=" + this.Division+"&RptType=Entry").subscribe((res: any) => {
    this.S_CompanyName_Row = JSON.parse(res).record;
    this.Search_Company = this.S_CompanyName_Row[0].value;
    this.isload = false;
    });
  }

  public S_Employee_Details_Row=[];
  public Search_Employee = "0";
  get_S_Employee_Details() {
    debugger
    this.isload = true;
    this.S_Employee_Details_Row=[];
    this.get("Api/transaction/get_Employee_Details?UserId=" + this.UserId + "&Branch=" + this.Search_Branch + "&Division=" + this.Division+"&RptType=Entry").subscribe((res: any) => {
    this.S_Employee_Details_Row = JSON.parse(res).record;
    this.Search_Employee = this.S_Employee_Details_Row[0].value;
    this.isload = false;
    });
  }

  public S_Branch_Details_Row=[];
  public Search_Branch = "0";
  get_S_Branch_Details() {
    this.isload = true;
    this.S_Branch_Details_Row=[];
    this.get("Api/transaction/get_Branch_Details?Branch=" + this.Branch + "&Division=" + this.Division+"&RptType=Entry").subscribe((res: any) => {
    this.S_Branch_Details_Row = JSON.parse(res).record;
    this.Search_Branch = this.S_Branch_Details_Row[0].value;
    this.Default_Search_Branch = this.Search_Branch ;
      this.get_S_Employee_Details();
    this.isload = false;
    });
  }

  public CompanyName_Rows = [];
  get_Company_Details() {
    this.Employee_Details_Rows = [];
    this.getc("Api/Master/get_Company_Details1").subscribe((res: any) => {
      this.CompanyName_Rows = JSON.parse(res).record;
    });
  }


  public Employee_Details_Rows = [];
  get_Employee_Details() {
    this.Employee_Details_Rows = [];
    this.getc("Api/Master/get_Employee_Details1").subscribe((res: any) => {
      this.Employee_Details_Rows = JSON.parse(res).record;
    });
  }
  
  public S_Employee_Details_Rpt_Row=[];
  public Search_Employee_Rpt = "0";
  get_S_Employee_Details_Rpt() {
    this.isload = true;
    this.S_Employee_Details_Rpt_Row=[];
    this.get("Api/transaction/get_Employee_Details?UserId=" + this.UserId + "&Branch=" + this.Search_Branch + "&Division=" + this.Division+"&RptType=Reports").subscribe((res: any) => {
    this.S_Employee_Details_Rpt_Row = JSON.parse(res).record;
    this.Search_Employee_Rpt = this.S_Employee_Details_Rpt_Row[0].value;
    this.isload = false;
    });
  }

  public S_Branch_Details_Rpt_Row=[];
  public Search_Branch_Rpt = "0";
  get_S_Branch_Details_Rpt() {
    this.isload = true;
    this.S_Branch_Details_Rpt_Row=[];
    this.get("Api/transaction/get_Branch_Details?Branch=" + this.Branch + "&Division=" + this.Division+"&RptType=Reports").subscribe((res: any) => {
    this.S_Branch_Details_Rpt_Row = JSON.parse(res).record;
    this.Search_Branch_Rpt = this.S_Branch_Details_Rpt_Row[0].value;
      this.get_S_Employee_Details_Rpt();
    this.isload = false;
    });
  }

  public Region_Master_Export = [];
  public Region_order_by=" rm_id asc";
  public Region_Master_Rows = [];
  public Region_Master_col_GF = ['rm_company_name','rm_region_name'];
 
  get_Region_Master() {
    this.isload = true;
      this.get("Api/Master/get_Region_Master?Status="+this.Status+"&Order_by="+this.Region_order_by).subscribe((res: any) => {
      this.isload = false;
      this.Region_Master_Rows = JSON.parse(res).record;
    });
  }

  public Branch_Master_Export = [];
  public Branch_order_by=" bm_id asc";
  public Branch_Master_Rows = [];
  public Branch_Master_col_GF = ['bm_company_name','bm_branch_name'];
 
  get_Branch_Master() {
    this.isload = true;
      this.get("Api/Master/get_Branch_Master?Status="+this.Status+"&Order_by="+this.Branch_order_by).subscribe((res: any) => {
      this.isload = false;
      this.Branch_Master_Rows = JSON.parse(res).record;
    });
  }

  public Contact_order_by=" con_Id asc";
  public Contact_Master_Rows = [];
  public Contact_Master_col_GF = ['con_ContactName','con_CompanyName','con_Mobile','con_Email','con_Designation','con_Skype','con_Notes','con_LinkedIN'];

  public Company_order_by=" cm_ID asc";
  public Company_Master_Rows = [];
  public Company_Master_col_GF = ['cm_CompanyName','cm_Notes','cm_IndustryType','cm_Employees','cm_EmailID','cm_Phone','cm_Address','cm_Website'];

  public Employee_Master_Export = [];
  public Employee_order_by=" emp_id asc";
  public Employee_Master_Rows = [];
  public Employee_Master_col_GF = ['emp_company_name','emp_name'];
 
  get_Employee_Master() {
    this.isload = true;
      this.get("Api/Master/get_Employee_Master?Status="+this.Status+"&Order_by="+this.Employee_order_by).subscribe((res: any) => {
      this.isload = false;
      this.Employee_Master_Rows = JSON.parse(res).record;
    });
  }

  get_Company_Master() {
    this.isload = true;
      this.get("Api/Master/get_Company_Master?Status="+this.Status+"&Order_by="+this.Company_order_by).subscribe((res: any) => {
      this.isload = false;
      this.Company_Master_Rows = JSON.parse(res).record;
    });
  }

  get_Contact_Master() {
    this.isload = true;
      this.get("Api/Master/get_Contact_Master?Status="+this.Status+"&Order_by="+this.Contact_order_by).subscribe((res: any) => {
      this.isload = false;
      this.Contact_Master_Rows = JSON.parse(res).record;
    });
  }


  public Agent_Master_Export = [];
  public Agent_order_by=" am_id asc";
  public Agent_Master_Rows = [];
  public Agent_Master_col_GF = ['am_company_name','am_agentname'];
 
  get_Agent_Master() {
    this.isload = true;
      this.get("Api/Master/get_Agent_Master?Status="+this.Status+"&Order_by="+this.Agent_order_by).subscribe((res: any) => {
      this.isload = false;
      this.Agent_Master_Rows = JSON.parse(res).record;
    });
  }


  public Chit_Value_Master_Export = [];
  public Chit_Value_order_by=" cv_id asc";
  public Chit_Value_Master_Rows = [];
  public Chit_Value_Master_col_GF = ['cv_chit_value','cv_month'];
 
  get_Chit_Value_Master() {
    this.isload = true;
      this.get("Api/Master/get_Chit_Value_Master?Status="+this.Status+"&Order_by="+this.Chit_Value_order_by).subscribe((res: any) => {
      this.isload = false;
      
      this.Chit_Value_Master_Rows = JSON.parse(res).record;
    });
  }

  public TaskBooking_Entry_Export = [];
  public TaskBooking_Entry_order_by=" lead_id asc";
  public TaskBooking_Entry_Rows = [];
  public TaskBooking_Entry_col_GF = ['tb_DealName','tb_TypeOfTask','tb_Remainder','tb_Notes','tb_IsCompleted','tb_Date'];
 
  get_TaskBooking_Entry1() {
    this.isload = true;
    this.EmpName = JSON.parse(localStorage.getItem('User_Data'));
    this.TaskBooking_Entry_Rows=[];
      this.get("Api/transaction/get_TaskBooking_Entry?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch  + "&Employee=" + this.EmpName["UM_Full_Name"]).subscribe((res: any) => {
      this.isload = false;
      this.TaskBooking_Entry_Rows = JSON.parse(res).record;
    });
  }

  get_TaskBooking_Entry() {
    this.isload = true;
    this.EmpName = JSON.parse(localStorage.getItem('User_Data'));
    this.TaskBooking_Entry_Rows=[];
      this.get("Api/transaction/get_TaskBooking_Entry1?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch  + "&Employee=" + this.EmpName["UM_Full_Name"]).subscribe((res: any) => {
      this.isload = false;
      this.TaskBooking_Entry_Rows = JSON.parse(res).record;
    });
  }

  public Pipeline_Entry_Export = [];
  public Pipeline_Entry_order_by=" lead_id asc";
  public Pipeline_Entry_Rows = [];
  public Pipeline_Entry_col_GF = ['pl_CompanyName','pl_Id','pl_ContactName','pl_Stage','pl_ClosingDate','pl_DealWorth','pl_Notes'];
 

  public EmpName = ""; 
  
  get_Pipeline_Entry() {
    debugger
    this.isload = true;
    this.EmpName = JSON.parse(localStorage.getItem('User_Data'));
    this.Lead_Entry_Rows=[];
      this.get("Api/transaction/get_Pipeline_Entry1?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch  + "&Employee=" + this.EmpName["UM_Full_Name"]).subscribe((res: any) => {
      this.isload = false;
      this.Pipeline_Entry_Rows = JSON.parse(res).record;
    });
  }

  get_Pipeline_Entry1() {
    this.isload = true;
    this.Lead_Entry_Rows=[];
      this.get("Api/transaction/get_Pipeline_Entry?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch  + "&Employee=" + this.EmpName["UM_Full_Name"]).subscribe((res: any) => {
      this.isload = false;
      this.Pipeline_Entry_Rows = JSON.parse(res).record;
    });
  }


  public Lead_Entry_Export = [];
  public Lead_Entry_order_by=" lead_id asc";
  public Lead_Entry_Rows = [];
  public Lead_Entry_col_GF = ['cv_chit_value','cv_month'];
 
  get_Lead_Entry() {
    this.isload = true;
    this.Lead_Entry_Rows=[];
      this.get("Api/transaction/get_Lead_Entry?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch  + "&Employee=" + this.Search_Employee).subscribe((res: any) => {
      this.isload = false;
      this.Lead_Entry_Rows = JSON.parse(res).record;
    });
  }


  public Followup_Details_Export = [];
  public Followup_Details_order_by=" lead_id asc";
  public Followup_Details_Rows = [];
  public Followup_Details_col_GF = ['cv_chit_value','cv_month'];
 
  get_Followup_Details() {
    this.isload = true;
    this.Followup_Details_Rows=[];
      this.get("Api/transaction/get_Followup_Details?Lead_Type=" + this.S_Type + "&Branch=" + this.Search_Branch + "&Employee=" +this.Search_Employee).subscribe((res: any) => {
      this.isload = false;
      this.Followup_Details_Rows = JSON.parse(res).record;
    });
  }

  
  public FeedBack_Export = [];
  public FeedBack_order_by=" fd_id asc";
  public FeedBack_Rows = [];
  public FeedBack_col_GF = ['cv_chit_value','cv_month'];
 
  get_FeedBack() {
    this.isload = true;
    this.FeedBack_Rows=[];
      this.get("Api/transaction/get_FeedBack?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch  + "&Employee=" + this.Search_Employee).subscribe((res: any) => {
      this.isload = false;
      this.FeedBack_Rows = JSON.parse(res).record;
    });
  }


  public Lead_Entry_Report_Export = [
    { Field: 'Lead_No', Name: 'Lead No', Align: '' },
    { Field: 'Input_Date', Name: 'Input Date', Align: '' },
    { Field: 'Subscriber_Name', Name: 'Subscriber Name', Align: '' },
    { Field: 'Mobile_No', Name: 'Mobile No', Align: 'right' },
    { Field: 'Town', Name: 'Town', Align: 'right' },
    { Field: 'Occupation', Name: 'Occupation', Align: 'right' },
    { Field: 'Employee_Name', Name: 'Employee Name', Align: 'right' },
  
  ];
  public Lead_Entry_GF = ['Lead_No', 'Input_Date', 'Subscriber_Name', 'Mobile_No', 'Occupation', 'Town', 'Employee_Name'];
  public Lead_Entry_Row = [];
  get_Lead_Entry_Report() {
    this.isload = true;
    this.get("Api/reports/get_Lead_Entry_Report?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch_Rpt  + "&Employee=" + this.Search_Employee_Rpt ).subscribe((res: any) => {   
      this.isload = false;
      this.Lead_Entry_Row = JSON.parse(res).record;
    });
  
  }

  // public Summary_GF = ['Lead_No', 'Input_Date', 'Subscriber_Name', 'Mobile_No', 'Occupation', 'Town', 'Employee_Name'];
  // public SummaryReport_Row = [];
  // get_SummaryReport(deal) {
  //   debugger
  //   this.isload = true;
  //   this.get("Api/reports/get_SummaryReport?From=" + this.S_From + "&To=" + this.S_To + "&Deal=" + deal).subscribe((res: any) => {   
  //     this.isload = false;
  //     this.SummaryReport_Row = JSON.parse(res).record;
  //   }); 
  // }


  public Summary_GF = ['Lead_No', 'Input_Date', 'Subscriber_Name', 'Mobile_No', 'Occupation', 'Town', 'Employee_Name'];
public SummaryReport_Row = [];

get_SummaryReport(deal: string) {
  this.isload = true;

  let url = "";

  
  if (this.S_From && this.S_To && !deal) {
    url = `Api/reports/get_SummaryReport?From=${this.S_From}&To=${this.S_To}&Deal=`;
  }
  
  else if (deal && (!this.S_From && !this.S_To)) {
    url = `Api/reports/get_SummaryReport?From=&To=&Deal=${deal}`;
  }
  
  else {
    alert("Please select either (From & To) OR Deal — not both.");
    this.isload = false;
    return;
  }

  this.get(url).subscribe((res: any) => {
    this.isload = false;
    this.SummaryReport_Row = JSON.parse(res).record;
  });
}

  public Status_Report_Export = [
    { Field: 'Lead_No', Name: 'Lead No', Align: '' },
    { Field: 'Input_Date', Name: 'Input Date', Align: '' },
    { Field: 'Subscriber_Name', Name: 'Subscriber Name', Align: '' },
    { Field: 'Mobile_No', Name: 'Mobile No', Align: 'right' },
    { Field: 'Town', Name: 'Town', Align: 'right' },
    { Field: 'Occupation', Name: 'Occupation', Align: 'right' },
    { Field: 'Lead_Rating', Name: 'Rating', Align: 'right' },
    { Field: 'Lead_Status', Name: 'Lead Status', Align: 'right' },
    { Field: 'Remainder_Date', Name: 'Remainder Date', Align: 'right' },
    { Field: 'Remainder_Note', Name: 'Remainder Note', Align: 'right' },
    { Field: 'Status', Name: 'Status', Align: 'right' },
    { Field: 'Employee_Name', Name: 'Employee Name', Align: 'right' },
  
  ];
  public Status_Report_GF = ['Lead_No', 'Input_Date', 'Subscriber_Name', 'Mobile_No', 'Town','Occupation', 'Remainder_Date','Remainder_Note', 'Lead_Status', 'Status', 'Employee_Name'];
  public Status_Report_Row = [];
  get_Status_Report() {
    this.isload = true;
    this.get("Api/reports/get_Status_Report?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch_Rpt  + "&Employee=" + this.Search_Employee_Rpt ).subscribe((res: any) => {   
      this.isload = false;
      this.Status_Report_Row = JSON.parse(res).record;
    }); 
  }

  
  public Follow_Up_Report_Export = [
    { Field: 'Lead_No', Name: 'Lead No', Align: '' },
    { Field: 'Input_Date', Name: 'Input Date', Align: '' },
    { Field: 'Subscriber_Name', Name: 'Subscriber Name', Align: '' },
    { Field: 'Mobile_No', Name: 'Mobile No', Align: 'right' },
    { Field: 'Town', Name: 'Town', Align: 'right' },
    { Field: 'Occupation', Name: 'Occupation', Align: 'right' },
    { Field: 'Status', Name: 'Status', Align: 'right' },
    { Field: 'Updated_Date', Name: 'Updated Date', Align: 'right' },
    { Field: 'Employee_Name', Name: 'Employee Name', Align: 'right' },
    { Field: 'Lead_Rating', Name: 'Rating', Align: 'right' },
    { Field: 'Lead_Status', Name: 'Lead Status', Align: 'right' },
    { Field: 'Remainder_Date', Name: 'Remainder Date', Align: 'right' },
    { Field: 'Remainder_Note', Name: 'Remainder Note', Align: 'right' },
  
  ];
  public Follow_Up_Report_GF = ['Lead_No', 'Input_Date', 'Subscriber_Name', 'Mobile_No', 'Town','Occupation', 'Updated_Date','Remainder_Date','Remainder_Note', 'Lead_Status', 'Status', 'Employee_Name'];
  public Follow_Up_Report_Row = [];
  get_Follow_Up_Report() {
    this.isload = true;
    this.get("Api/reports/get_Follow_Up_Report?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch_Rpt  + "&Employee=" + this.Search_Employee_Rpt ).subscribe((res: any) => {     
      this.isload = false;
      this.Follow_Up_Report_Row = JSON.parse(res).record;
    });
  }
 
  
  public Dishonoured_Report_Export = [
    { Field: 'Lead_No', Name: 'Lead No', Align: '' },
    { Field: 'Input_Date', Name: 'Input Date', Align: '' },
    { Field: 'Subscriber_Name', Name: 'Subscriber Name', Align: '' },
    { Field: 'Mobile_No', Name: 'Mobile No', Align: 'right' },
    { Field: 'Town', Name: 'Town', Align: 'right' },
    { Field: 'Occupation', Name: 'Occupation', Align: 'right' },
    { Field: 'Lead_Rating', Name: 'Rating', Align: 'right' },
    { Field: 'Lead_Status', Name: 'Lead Status', Align: 'right' },
    { Field: 'Remainder_Date', Name: 'Remainder Date', Align: 'right' },
    { Field: 'Remainder_Note', Name: 'Remainder Note', Align: 'right' },
    { Field: 'Status', Name: 'Status', Align: 'right' },
    { Field: 'Employee_Name', Name: 'Employee Name', Align: 'right' },
  
  ];
  public Dishonoured_Report_GF = ['Lead_No', 'Input_Date', 'Subscriber_Name', 'Mobile_No', 'Town','Occupation', 'Remainder_Date','Remainder_Note', 'Lead_Status', 'Status', 'Employee_Name'];
  public Dishonoured_Report_Row = [];
  get_Dishonoured_Report() {
    this.isload = true;
    this.get("Api/reports/get_Dishonoured_Report?From=" + this.S_From + "&To=" + this.S_To + "&Branch=" + this.Search_Branch_Rpt  + "&Employee=" + this.Search_Employee_Rpt ).subscribe((res: any) => {   
      this.isload = false;
      this.Dishonoured_Report_Row = JSON.parse(res).record;
    }); 
  }


  public Search_Customer="";

  
  public lead_calendar_Report_Export = [
    { Field: 'Branch', Name: 'Branch', Align: '' },
    { Field: 'Staff', Name: 'Staff', Align: '' },
    { Field: '[Grand Total]', Name: 'Grand Total', Align: '' },
  
  ];
  public lead_calendar_Report_GF = ['Branch', 'Staff'];
  public lead_calendar_Report_Row = [];

  
  public FollowUp_calendar_Report_Export = [
    { Field: 'Branch', Name: 'Branch', Align: '' },
    { Field: 'Staff', Name: 'Staff', Align: '' },
    { Field: '[Grand Total]', Name: 'Grand Total', Align: '' },
  
  ];
  public FollowUp_calendar_Report_GF = ['Branch', 'Staff'];
  public FollowUp_calendar_Report_Row = [];


  public Dishonoured_calendar_Report_Export = [
    { Field: 'Branch', Name: 'Branch', Align: '' },
    { Field: 'Staff', Name: 'Staff', Align: '' },
    { Field: '[Grand Total]', Name: 'Grand Total', Align: '' },
  
  ];
  public Dishonoured_calendar_Report_GF = ['Branch', 'Staff'];
  public Dishonoured_calendar_Report_Row = [];
 

  getLocationLink(): Promise<string | null> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {         
          const { latitude, longitude } = position.coords;
          resolve(`https://www.google.com/maps?q=${latitude},${longitude}`);
        },
        (error) => {
          console.error('Error getting location:', error);
          resolve(null); // Resolve with null in case of an error
        }
      );
    });
  }
    getDashboardSummary(): Observable<any> {
    return of({
      total: 120,
      open: 30,
      closed: 20,
      inprogress: 10,
      pendingLeads: [
        {
          tl_date: '2025-01-10',
          tl_subscriber_name: 'John',
          tl_mobile_no: '9999999999',
          tl_vstatus: 'Pending'
        }
      ],
      lastWeek: [
        { date: '01-01', customer: 'ABC', task: 'Call', status: 'Done' }
      ],
      currentWeek: [
        { date: '01-15', customer: 'XYZ', task: 'Meeting', status: 'Pending' }
      ],
      upcomingWeek: [
        { date: '01-20', customer: 'PQR', task: 'Demo', status: 'Planned' }
      ]
    });
  }

  getNewCompanies(): Observable<any[]> {
    return of([
      { companyName: 'ABC Corp', pipelineCount: 3, createdDate: '2025-01-12' },
      { companyName: 'XYZ Pvt Ltd', pipelineCount: 0, createdDate: '2025-01-14' }
    ]);
  }

}
